import React from "react";
import { Provider } from "react-redux";
import { store } from "./store";
import Routera from "./Router";
import axios from "axios";

const App = () => {
  axios.defaults.withCredentials = true;
  document.addEventListener("message", function () {
    //let token = data.data;
  });
  return (
    <Provider store={store}>
      <Routera />
    </Provider>
  );
};

export default App;
